import axios from "axios";
import Mgr from "@/services/SecurityService";
var user = new Mgr();

const HTTP = axios.create({
  baseURL: `${process.env.API}/api/`,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
    xsrfCookieName: "XSRF-TOKEN", // default
    // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
    xsrfHeaderName: "X-XSRF-TOKEN" // default

    // Authorization: 'Bearer ' + token
  },
  params: {}
});

user.getIdToken().then(accessToken => {
  HTTP.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${accessToken.id_token}`;
}).catch((e) => {
  console.info(`LoggerInfo: ${e.message}`);
});
export default HTTP;
